import styled from 'styled-components';

export const ModalWrapper = styled.div``;
